import { Flex, Link } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../../../ui-components';
import { useContentAsset } from '../../../../../../utils/api';
import { ContentAssetID } from '../../../../../../utils/api/ContentAssetID';
import { sanitizeHtml } from '../../../../../content-asset/sanitize-html';
import { ArrowRightIcon } from '../../../../../icons';
import styles from '../MenuCategoryDesktop.module.scss';
import type { Category } from '../../../../../../bff-api/categories/model/category';

interface Props {
    brands: Category;
}

export const MenuCategoryBrandsDesktop: React.FC<Props> = ({ brands }) => {
    const brandsAE = useContentAsset(ContentAssetID.BRANDS_A_E);
    const brandsFJ = useContentAsset(ContentAssetID.BRANDS_F_J);
    const brandsKO = useContentAsset(ContentAssetID.BRANDS_K_O);
    const brandsPT = useContentAsset(ContentAssetID.BRANDS_P_T);
    const brandsU123 = useContentAsset(ContentAssetID.BRANDS_U_123);

    return (
        <Flex
            data-testid="header.menu.desktop.category.brands.content"
            gap={8}
            height="fit-content"
        >
            <Flex direction="column" grow={1} gap={8} className={styles.menu_brands}>
                <Flex columnGap={8}>
                    {brandsAE ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.a_e"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsAE),
                            }}
                        />
                    ) : null}

                    {brandsFJ ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.f_j"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsFJ),
                            }}
                        />
                    ) : null}
                </Flex>

                <Flex columnGap={8}>
                    {brandsKO ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.k_o"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsKO),
                            }}
                        />
                    ) : null}

                    {brandsPT ? (
                        <Flex
                            data-testid="header.menu.desktop.category.brands.p_t"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(brandsPT),
                            }}
                        />
                    ) : null}
                </Flex>

                {brandsU123 ? (
                    <Flex
                        data-testid="header.menu.desktop.category.brands.u_123"
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(brandsU123),
                        }}
                    />
                ) : null}
            </Flex>

            <Flex direction="column" justifyContent="space-between" width="20%">
                {brands.headerMenuBanner1 ? (
                    <Flex
                        data-testid="header.menu.desktop.category.brands.banner1"
                        direction="column"
                        rowGap={4}
                        maxWidth="248px"
                        textStyle="body-base"
                        className={styles.menu_banner}
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(brands.headerMenuBanner1),
                        }}
                    />
                ) : null}

                {brands.showShopAllLink ? (
                    <Link data-testid="header.menu.desktop.category.brands.link" href={brands.url}>
                        <Flex
                            grow={1}
                            shrink={0}
                            gap={2}
                            alignItems="center"
                            justifyContent="flex-end"
                        >
                            <Text size="small" style="bolder">
                                <FormattedMessage
                                    id="header.see.all.featured"
                                    defaultMessage="See All Featured {category}"
                                    values={{
                                        category: brands.displayName,
                                    }}
                                />
                            </Text>
                            <ArrowRightIcon marginBottom={0.5} />
                        </Flex>
                    </Link>
                ) : null}
            </Flex>
        </Flex>
    );
};

MenuCategoryBrandsDesktop.propTypes = {
    brands: PropTypes.any.isRequired,
};
